export enum Breakpoints {
  Mobile = '375px',
  Tablet = '769px',
  Desktop = '1025px',
  LargeDesktop = '1441px',
}
